import { useState } from 'react';

const directivo = [
  { cargo: "Presidente", nombre: "Pablo Bernardino Céspedes Cruz", tratamiento: "R.·. H.·." },
  { cargo: "Vicepresidente", nombre: "Ramón Cueva Cruzado", tratamiento: "R.·. H.·." },
  { cargo: "Secretario", nombre: "Guillermo Marcelo Debernardi Martino", tratamiento: "R.·. H.·." },
  { cargo: "Tesorero", nombre: "Abel Eduardo Contreras Sufling", tratamiento: "R.·. H.·." },
  { cargo: "Director de Instrucción", nombre: "Ysaac Rubén Chipayo Gonzáles", tratamiento: "R.·. H.·." },
  { cargo: "Director de Difusión", nombre: "Juan Martín Velasco Cárdenas", tratamiento: "R.·. H.·." },
  { cargo: "Dir. Relaciones Institucionales", nombre: "José Jorge Delgadillo Sánchez", tratamiento: "Q.·. H.·." },
  { cargo: "Director de Investigación", nombre: "Yul Milke Palza Valdivia", tratamiento: "Q.·. H.·." }
];

const representantes = [
  { nombre: "Juan Martín Velasco Cárdenas", logia: "Centro Cósmico N° 163", tratamiento: "R.·. H.·." },
  { nombre: "Yul Milke Palza Valdivia", logia: "Mariano Melgar N° 222", tratamiento: "R.·. H.·." },
  { nombre: "José Jorge Delgadillo Sánchez", logia: "Antonio José de Sucre N° 125", tratamiento: "R.·. H.·." }
];

const Adaem = () => {
  const [activeTab, setActiveTab] = useState('institucional');

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Instrucción Masónica
          </p>
          <h1 className="font-serif text-5xl md:text-7xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            ADAEM
          </h1>
          <p className="text-gray-300 font-light text-sm md:text-lg tracking-widest uppercase animate-fade-in [animation-delay:0.6s]">
            Academia de Docencia y Altos Estudios Masónicos
          </p>
        </div>
      </section>

      {/* Navegación de Pestañas (Tabs) */}
      <div className="sticky top-[88px] z-40 bg-[#0a0a0a]/95 backdrop-blur-xl border-b border-white/10 shadow-2xl">
        <div className="max-w-4xl mx-auto px-4 flex justify-center">
          <div className="flex gap-4 md:gap-12">
            <button
              onClick={() => setActiveTab('institucional')}
              className={`py-4 px-2 text-xs md:text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300 border-b-2 ${
                activeTab === 'institucional' 
                  ? 'border-[#C5A059] text-[#C5A059]' 
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              Organización y Contacto
            </button>
            <button
              onClick={() => setActiveTab('historia')}
              className={`py-4 px-2 text-xs md:text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300 border-b-2 ${
                activeTab === 'historia' 
                  ? 'border-[#C5A059] text-[#C5A059]' 
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              Reseña Histórica
            </button>
          </div>
        </div>
      </div>

      {/* Contenido Dinámico */}
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12 py-16">
        
        {/* --- PESTAÑA 1: INSTITUCIONAL --- */}
        {activeTab === 'institucional' && (
          <div className="animate-fade-in grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
            
            {/* Columna Izquierda: Directorio y Representantes */}
            <div className="lg:col-span-7 flex flex-col gap-12">
              
              {/* Consejo Directivo */}
              <div>
                <div className="mb-6 border-b border-white/10 pb-4 flex flex-col sm:flex-row justify-between sm:items-end gap-4">
                  <h3 className="font-serif text-2xl md:text-3xl text-white">Consejo Directivo</h3>
                  <div className="text-left sm:text-right">
                    <p className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1 inline-block">Decreto N° 142-153-GLP</p>
                    <p className="text-gray-500 text-[10px] tracking-widest uppercase mt-2">01 de Octubre de 2024</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2 bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] p-6 shadow-lg">
                    <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{directivo[0].cargo}</span>
                    <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">{directivo[0].tratamiento}</p>
                    <h4 className="font-serif text-2xl text-white">{directivo[0].nombre}</h4>
                  </div>
                  
                  {directivo.slice(1).map((miembro, idx) => (
                    <div key={idx} className="bg-[#0a0a0a] border border-white/5 p-6 hover:border-[#C5A059]/30 transition-colors">
                      <span className="text-gray-400 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{miembro.cargo}</span>
                      <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">{miembro.tratamiento}</p>
                      <h4 className="font-serif text-lg text-white">{miembro.nombre}</h4>
                    </div>
                  ))}
                </div>
              </div>

              {/* Representantes del Gran Maestro */}
              <div>
                <div className="mb-6 border-b border-white/10 pb-4 flex flex-col sm:flex-row justify-between sm:items-end gap-4">
                  <h3 className="font-serif text-xl md:text-2xl text-gray-300">Representantes del Gran Maestro<br/><span className="text-sm font-sans font-light tracking-wide text-gray-500 block mt-2">ante el Consejo Directivo de la ADAEM</span></h3>
                  <div className="text-left sm:text-right">
                    <p className="text-gray-400 text-[10px] tracking-widest uppercase border border-gray-600 px-2 py-1 inline-block">Decreto N° 142-101-GLP</p>
                    <p className="text-gray-500 text-[10px] tracking-widest uppercase mt-2">31 de Julio de 2024</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {representantes.map((rep, idx) => (
                    <div key={idx} className="bg-[#050505] border border-white/5 p-6 hover:bg-white/[0.02] transition-colors">
                      <p className="text-gray-600 text-[10px] tracking-widest uppercase mb-1">{rep.tratamiento}</p>
                      <h4 className="font-serif text-lg text-gray-300 mb-2">{rep.nombre}</h4>
                      <p className="text-[#C5A059] text-xs font-light tracking-wide">R.·. L.·. S.·. {rep.logia}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>

            {/* Columna Derecha: Contacto (Sticky) */}
            <div className="lg:col-span-5">
              <div className="sticky top-40 flex flex-col gap-6">
                
                <div className="bg-[#0a0a0a] border border-white/5 p-8 md:p-10 shadow-xl">
                  <h3 className="font-serif text-2xl text-white mb-8 border-b border-white/10 pb-4">Contacto y Sedes</h3>
                  
                  <div className="space-y-6">
                    <div>
                      <span className="flex items-center gap-3 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase mb-2">Dirección</span>
                      <p className="text-gray-300 font-light text-sm pl-7">Av. José Gálvez Barrenechea N°599, San Isidro</p>
                    </div>
                    <div>
                      <span className="flex items-center gap-3 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase mb-2">Central Telefónica</span>
                      <p className="text-gray-300 font-light text-sm pl-7">475-0994 <span className="text-[#C5A059] mx-1">|</span> 475-0999</p>
                    </div>
                    <div>
                      <span className="flex items-center gap-3 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase mb-2">Correo Electrónico</span>
                      <a href="mailto:academia@glperu.org.pe" className="text-gray-300 hover:text-[#C5A059] transition-colors font-light text-sm pl-7 block">academia@glperu.org.pe</a>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-l-2 border-[#C5A059] p-8 md:p-10 shadow-xl">
                  <h4 className="text-white font-serif text-xl mb-6">Horarios de Atención</h4>
                  <div className="space-y-5">
                    <div>
                      <span className="block text-gray-500 text-xs tracking-widest uppercase mb-1">Días de Atención</span>
                      <p className="text-gray-300 font-medium text-sm">De Lunes a Viernes</p>
                    </div>
                    <div className="pl-4 border-l border-white/10">
                      <span className="block text-[#C5A059] text-[10px] tracking-widest uppercase mb-1">Empleado de la GLP</span>
                      <p className="text-gray-300 font-light text-sm">De 15:00 a 21:00 Horas</p>
                    </div>
                    <div className="pl-4 border-l border-white/10">
                      <span className="block text-[#C5A059] text-[10px] tracking-widest uppercase mb-1">Académicos</span>
                      <p className="text-white font-medium text-sm">De 19:00 a 22:00 Horas</p>
                    </div>
                  </div>
                </div>

                <p className="text-center text-gray-600 text-[10px] tracking-widest uppercase mt-2">
                  Actualizado al 15/09/2025
                </p>

              </div>
            </div>
          </div>
        )}

        {/* --- PESTAÑA 2: HISTORIA --- */}
        {activeTab === 'historia' && (
          <div className="animate-fade-in max-w-4xl mx-auto bg-[#0a0a0a] border border-white/5 p-8 md:p-16 shadow-2xl">
            
            <div className="text-center mb-12">
              <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-2 block">Memoria Institucional</span>
              <h3 className="font-serif text-3xl md:text-5xl text-white font-normal">Historia de la ADAEM</h3>
              <div className="w-16 h-[1px] bg-[#C5A059] mx-auto mt-6"></div>
            </div>

            <div className="prose prose-invert prose-lg max-w-none text-gray-300 font-light leading-relaxed text-justify">
              <p className="mb-8">
                <span className="float-left text-7xl md:text-8xl text-[#C5A059] font-serif pr-4 leading-[0.8] mt-2 drop-shadow-md">
                  E
                </span>
                l azaroso camino recorrido a través del tiempo, las épocas y las circunstancias de la realidad que constituye ahora la Academia de Altos Estudios Masónicos, la podemos exponer de la siguiente forma cronológica:
              </p>

              <p>
                <strong>1946:</strong> A iniciativa del R.·.H.·. Ángel Santos Parodi Vaccaro, se crea mediante Decreto de Gran Maestría el primer Centro de Estudios Masónicos con la finalidad de impartir enseñanza en estudios esotéricos.
              </p>

              <p>
                <strong>1966:</strong> Luego de veinte años, el M.·.R.·.H.·. Luis E. Heysen Incháustegui, dispone la formación de un Centro de Altos Estudios Masónicos. Con fecha 28 de setiembre de 1966, se expide el Decreto Nº 46 nombrando el primer cuerpo directivo. En mérito y reconocimiento, el Centro toma el nombre del R.·. H.·. Ángel Santos Parodi Vaccaro. La sede de Lima funcionaba en la calle Mantas y por Decreto Nº 25 se crearon filiales en Piura, Chiclayo, Trujillo, Cajamarca, Ica, Huancayo, Arequipa, Cuzco, Tacna e Iquitos. Desafortunadamente este centro tuvo una corta existencia.
              </p>

              <p>
                <strong>1980:</strong> Mediante Decreto 17-80 del 6 de mayo, se nombra una comisión encargada del Centro de Docencia y Estudios Masónicos presidida por el R.·.H.·. Luis Curotto de la Cruz, encargada de confeccionar circulares de instrucción para los grados de Aprendiz, Compañero y Maestro.
              </p>

              <p>
                <strong>1984:</strong> El cuarto intento lo hizo el M.·.R.·.H.·. Luis Panesi Martínez por Decreto Nº 103 que encarga a la Gran Comisión de Docencia la organización y presupuesto, autorizándose el primer curso para maestros y en 1986 el primer Ciclo de Docencia para el grado de aprendiz.
              </p>

              <p>
                <strong>1986:</strong> El quinto intento ocurre el 17 de abril. Se expide el Decreto Nº 105-86-336 del M.·.R.·.H.·. Luciano Baquerizo Zuzaeta, dando inicio al I Ciclo de Docencia Masónica en el templo de Corpac.
              </p>

              <p>
                <strong>1988:</strong> El sexto intento lo hace Ricardo Noriega Salaverry por Decreto 107 del 20 de agosto que crea un Centro de Estudios Masónicos de breve existencia. La intermitencia parecía inexorable.
              </p>

              <div className="my-12 border-t border-b border-white/10 py-8">
                <h4 className="font-serif text-[#C5A059] text-2xl mb-4">La Consolidación Definitiva</h4>
                <p>
                  La Constitución de la M.·.R.·. Gran Logia del Perú, en la segunda parte del Art. 64° considera que en la sede de la Gran Logia funciona la Academia de Docencia y Altos Estudios Masónicos. 
                </p>
                <p>
                  El M.·.R.·.H.·. Tomás Álvarez Manrique, con fecha 19 de agosto del 2004, expide decretos designando a la Gran Comisión de Docencia. El 20 de diciembre del 2004 se puso en vigencia el Estatuto de la Academia, y el 23 de diciembre se expide el Decreto Nº 122-206-GLP, poniendo en vigencia el Programa de Docencia Masónica.
                </p>
              </div>

              <h4 className="font-serif text-white text-xl mt-8 mb-4">Primer Consejo Directivo ADAEM (2005)</h4>
              <p>
                El 15 de marzo del 2005 se expide el Decreto Nº 122-243-GLP, reconociéndose como Presidente al M.·.R.·.H.·. Luis Masalías Erausquín. Luego de un arduo trabajo se convocó al I Curso de Maestros Instructores el 4 de Junio del 2005. Los primeros eventos descentralizados se realizaron en el valle de Chiclayo en el año 2007.
              </p>

              <div className="bg-[#050505] p-8 border-l-2 border-[#C5A059] mt-8">
                <h5 className="text-white font-serif text-lg mb-4">Estructura Actual de Enseñanza</h5>
                <ul className="space-y-4 text-base text-gray-400 marker:text-[#C5A059]">
                  <li><strong>Seminario Taller para Aprendices:</strong> 32 horas de estudio. Temas: La iniciación, Historia GLP, Simbolismo, Ética y moral, Estatuto Civil, Fopremas, Comportamiento y Protocolo.</li>
                  <li><strong>Seminario Taller para Compañeros:</strong> 32 horas de trabajo. Temas: Historia del grado, Herramientas, Epistemología, Organización y gobierno de una logia, Filosofía del Grado, Comunicación eficiente.</li>
                </ul>
              </div>

              <p className="mt-8 italic text-gray-400">
                Los resultados alcanzados han sido fructíferos, realizando estos Cursos en forma continua. En el año 2020 se comenzó a brindar instrucción en forma virtual, alcanzando a mayor número de hermanos de todas las regiones del Perú.
              </p>

              <p className="text-right text-[#C5A059] text-sm tracking-widest uppercase mt-12">
                Fuente: R.·.H.·. Mario Martínez Rodríguez
              </p>
            </div>

          </div>
        )}

      </div>
    </div>
  );
};

export default Adaem;